import api from './api';

/**
 * Offers Service
 * Handles all offer management API calls
 */
const offersService = {
    /**
     * Get all offers with pagination and filters
     * @param {Object} params - Query parameters
     * @returns {Promise<Object>}
     */
    getAll: async (params = {}) => {
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/admin/offers${queryString ? `?${queryString}` : ''}`);
    },

    /**
     * Get offer by ID
     * @param {string} id - Offer ID
     * @returns {Promise<Object>}
     */
    getById: async (id) => {
        return api.get(`/admin/offers/${id}`);
    },

    /**
     * Approve offer
     * @param {string} id - Offer ID
     * @returns {Promise<Object>}
     */
    approve: async (id) => {
        return api.patch(`/admin/offers/${id}/approve`);
    },

    /**
     * Reject offer
     * @param {string} id - Offer ID
     * @param {string} reason - Rejection reason
     * @returns {Promise<Object>}
     */
    reject: async (id, reason) => {
        return api.patch(`/admin/offers/${id}/reject`, { reason });
    },

    /**
     * Delete offer
     * @param {string} id - Offer ID
     * @returns {Promise<Object>}
     */
    delete: async (id) => {
        return api.delete(`/admin/offers/${id}`);
    },

    /**
     * Export offers data
     * @param {Object} params - Query parameters
     * @returns {Promise<Object>}
     */
    export: async (params = {}) => {
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/admin/offers/export${queryString ? `?${queryString}` : ''}`);
    }
};

export default offersService;
